export * from './link'
export {default as BlockQuote} from './BlockQuote'
export {default as Caption} from './Caption'
export {default as H1} from './H1'
export {default as H2} from './H2'
export {default as H3} from './H3'
export {default as H4} from './H4'
export {default as H5} from './H5'
export {default as H6} from './H6'
export {default as Label} from './Label'
export {default as MarkedText} from './MarkedText'
export {default as P} from './P'
export {default as Serif} from './Serif'
export {default as BlueHr} from './BlueHr'
export {default as Hr} from './Hr'
export {default as NavyHr} from './NavyHr'
export {default as WhiteHr} from './WhiteHr'



// WEBPACK FOOTER //
// ./src/core/typography/index.js